import React from "react";
import { Spinner } from "react-bootstrap";
import { Collapse } from "react-collapse";

const CartSidebar = ({
  cart,
  count,
  items,
  open,
  setOpen,
  amount,
  referralDiscount,
  subtotal,
  discount,
  coupon,
  tax,
  deliveryCharge,
  total,
  step,
  setStep,
  proceedToSummary,
  proceedToReview,
  handlePlaceOrder,
  submitting,
}) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  React.useEffect(() => {
    setMobileOpen(false);
  }, [step]);

  return (
    <>
    <div className="sticky-top consumer-cart-desktop" style={{ top: "20px" }}>
      <div className="card" style={{ borderColor: "#fce100" }}>
        <div className="card-body">
          <h5 className="fw-bold mb-3 d-flex align-items-center gap-2">
            Cart
            {cart.length > 0 && <span className="badge" style={{ backgroundColor: "#252525", color: "#fce100" }}>{count}</span>}
          </h5>
          <hr />
          {cart.length === 0 ? (
            <p className="text-muted text-center mb-0">Cart is empty</p>
          ) : (
            <>
              <div style={{ maxHeight: "30vh", overflowY: "auto" }}>
                {items.map((group) => (
                  <div key={group.services_id} className="mb-2">
                    <div
                      className="d-flex justify-content-between align-items-center cursor-pointer"
                      onClick={() =>
                        setOpen((p) => ({
                          ...p,
                          [`preview_${group.services_id}`]: !p[`preview_${group.services_id}`],
                        }))
                      }
                    >
                      <strong style={{ fontSize: "13px" }}>{group.service}</strong>
                      <i
                        className={`fa-solid fa-angle-${
                          open[`preview_${group.services_id}`] ? "up" : "down"
                        }`}
                        style={{ fontSize: "12px" }}
                      ></i>
                    </div>
                    <Collapse isOpened={open[`preview_${group.services_id}`]}>
                      {group.items.map((item, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between align-items-start ps-2 py-1 border-bottom"
                          style={{ fontSize: "12px" }}
                        >
                          <div>
                            <span className="fw-medium">{item.name}</span>
                            <span className="text-muted d-block">
                              x{item.quantity}
                              {item.free_items > 0 && (
                                <span style={{ color: "#9b7f00" }}> ({item.free_items} free)</span>
                              )}
                            </span>
                            {item.addons?.map((ad) => (
                              <small key={ad.id} className="d-block text-muted">
                                + {ad.name} x{ad.qty}
                              </small>
                            ))}
                          </div>
                          <span className="fw-medium">
                            Rs.{" "}
                            {(
                              (item.quantity - (item.free_items || 0)) * item.price +
                              item.addons.reduce((s, a) => s + a.qty * a.price, 0)
                            ).toLocaleString()}
                          </span>
                        </div>
                      ))}
                    </Collapse>
                  </div>
                ))}
              </div>
              <hr />
              {/* Full pricing breakdown */}
              <div style={{ fontSize: "13px" }}>
                <div className="d-flex justify-content-between py-1">
                  <span>Total Items</span><span>{count} item(s)</span>
                </div>
                <div className="d-flex justify-content-between py-1">
                  <span>Item Price</span><span>Rs. {amount?.toLocaleString()}</span>
                </div>
                {referralDiscount > 0 && (
                  <div className="d-flex justify-content-between py-1 px-1" style={{ backgroundColor: "#fff9cc" }}>
                    <span>Referral Discount</span>
                    <span>- Rs. {Math.round(referralDiscount)?.toLocaleString()}</span>
                  </div>
                )}
                <div className="d-flex justify-content-between py-1">
                  <span>Subtotal</span><span>Rs. {Math.round(subtotal)?.toLocaleString()}</span>
                </div>
                {discount > 0 && (
                  <div className="d-flex justify-content-between py-1 px-1" style={{ backgroundColor: "#fff9cc" }}>
                    <span>Discount {coupon?.coupon?.code && `(${coupon.coupon.code})`}</span>
                    <span>-Rs. {Math.round(discount)?.toLocaleString()}</span>
                  </div>
                )}
                <div className="d-flex justify-content-between py-1">
                  <span>VAT / Tax</span><span>Rs. {Math.round(tax)?.toLocaleString()}</span>
                </div>
                <div className="d-flex justify-content-between py-1">
                  <span>Delivery Fee</span>
                  <span>Rs. {Math.round(deliveryCharge || 0)?.toLocaleString()}</span>
                </div>
                <hr className="my-1" />
                <div className="d-flex justify-content-between py-1 fw-bold">
                  <span>Total</span><span>Rs. {Math.round(total)?.toLocaleString()}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="d-flex flex-column gap-2 mt-3">
        {step > 1 && (
          <button className="btn btn-outline-secondary" onClick={() => setStep((s) => s - 1)}>
            ← Back
          </button>
        )}
        {step === 1 && cart.length > 0 && (
          <button className="btn consumer-order-primary fw-semibold" onClick={proceedToSummary}>
            Proceed to Summary →
          </button>
        )}
        {step === 2 && (
          <button className="btn consumer-order-primary fw-semibold" onClick={proceedToReview}>
            Proceed to Review →
          </button>
        )}
        {step === 3 && (
          <button
            className="btn consumer-order-primary fw-semibold"
            disabled={submitting}
            onClick={() => handlePlaceOrder()}
          >
            {submitting ? <Spinner size="sm" className="me-1" /> : null}
            Place Order
          </button>
        )}
      </div>
    </div>

    <div className={`consumer-cart-mobile ${mobileOpen ? "is-open" : ""}`}>
      {mobileOpen && (
        <div className="consumer-cart-mobile-details">
          <div className="d-flex justify-content-between py-1"><span>Total Items</span><strong>{count} item(s)</strong></div>
          <div className="d-flex justify-content-between py-1"><span>Item Price</span><strong>Rs. {amount?.toLocaleString()}</strong></div>
          {referralDiscount > 0 && <div className="d-flex justify-content-between py-1 consumer-cart-discount"><span>Referral Discount</span><strong>-Rs. {Math.round(referralDiscount).toLocaleString()}</strong></div>}
          <div className="d-flex justify-content-between py-1"><span>Subtotal</span><strong>Rs. {Math.round(subtotal).toLocaleString()}</strong></div>
          {discount > 0 && <div className="d-flex justify-content-between py-1 consumer-cart-discount"><span>Discount {coupon?.coupon?.code && `(${coupon.coupon.code})`}</span><strong>-Rs. {Math.round(discount).toLocaleString()}</strong></div>}
          <div className="d-flex justify-content-between py-1"><span>VAT / Tax</span><strong>Rs. {Math.round(tax).toLocaleString()}</strong></div>
          <div className="d-flex justify-content-between py-1"><span>Delivery Fee</span><strong>Rs. {Math.round(deliveryCharge || 0).toLocaleString()}</strong></div>
          <hr className="my-2" />
          <div className="d-flex justify-content-between fw-bold"><span>Total</span><span>Rs. {Math.round(total).toLocaleString()}</span></div>
        </div>
      )}
      <button type="button" className="consumer-cart-mobile-summary" onClick={() => setMobileOpen((value) => !value)} aria-expanded={mobileOpen}>
        <span><small>Total</small><strong>{count} Item{count === 1 ? "" : "s"}</strong></span>
        <i className={`fa-solid fa-chevron-${mobileOpen ? "down" : "up"}`} />
        <span className="text-end"><small>Estimate</small><strong>Rs. {Math.round(total).toLocaleString()}</strong></span>
      </button>
      <div className="consumer-cart-mobile-actions">
        {step > 1 && <button className="btn btn-outline-secondary" onClick={() => setStep((current) => current - 1)}>Back</button>}
        {step === 1 && cart.length > 0 && <button className="btn consumer-order-primary fw-semibold" onClick={proceedToSummary}>Proceed to Summary</button>}
        {step === 2 && <button className="btn consumer-order-primary fw-semibold" onClick={proceedToReview}>Proceed to Review</button>}
        {step === 3 && <button className="btn consumer-order-primary fw-semibold" disabled={submitting} onClick={() => handlePlaceOrder()}>{submitting ? <Spinner size="sm" className="me-1" /> : null}Place Order</button>}
      </div>
    </div>
    </>
  );
};

export default CartSidebar;
